// ----------------- React Native ---------------
import { SectionList } from "react-native";

import { Card } from "react-native-paper";
import type { FontSchemaType } from "../../font";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { CustomAppBar } from "../CustomAppbar";
import type { CustomAppBarProps } from "../CustomAppbar/types";
import { CustomListSubheader } from "../CustomListSubheader";
import ScrollContainer from "../ScrollContainer";
import MoreSettingsListItem from "./MoreSettingsListItem";
import type { MoreSettingsItem, MoreSettingsSection } from "./types";

interface Props {
	sections: MoreSettingsSection[];
	handleClickMoreSettingsItem: (type: MoreSettingsItem) => void;
	appFont: FontSchemaType;
	customAppBar: CustomAppBarProps;
}

const MoreApplet = ({
	sections,
	handleClickMoreSettingsItem,
	appFont,
	customAppBar,
}: Props) => {
	const { isMobile } = useDevice();
	const Wrapper = isMobile ? Box : Card;
	return (
		<Box position="relative" flexGrow={1} height={"100%"}>
			<CustomAppBar {...customAppBar} />
			<ScrollContainer
				style={{
					padding: isMobile ? 0 : 16,
				}}
				// biome-ignore lint/a11y/useSemanticElements: <explanation>
				role="main"
			>
				<Wrapper>
					<SectionList
						sections={sections}
						scrollEnabled={false}
						contentContainerStyle={{
							paddingTop: 16,
						}}
						renderSectionHeader={({ section: { sectionTitle } }) => {
							return (
								<CustomListSubheader font={appFont}>
									{sectionTitle}
								</CustomListSubheader>
							);
						}}
						renderItem={({ item }) => {
							return (
								<MoreSettingsListItem
									item={item}
									handleClick={handleClickMoreSettingsItem}
								/>
							);
						}}
					/>
				</Wrapper>
			</ScrollContainer>
		</Box>
	);
};

export default MoreApplet;
